import React, { useCallback } from 'react';
import { FormattedDate, FormattedMessage, FormattedTime } from 'react-intl';

import { useMessage } from '@tmapy/intl';

import { useAppContext, useHistoryAction } from '../../hooks';
import type { PriceListItemResponse } from '../../openapi/types/PriceListItem';
import { getCmdCtrlUrl } from '../../utils/getcmdctrlurl';
import { RouteId } from '../../routes';
import { PriceListItemUnitsEnum } from '../../openapi/types/PriceListItemUnitsEnum';

import { getPriceBandsPriceRange, isDataPriceListItemType } from '../utils';

import {
  priceListMessages as msg,
  priceListItemTypeMessages,
  priceListItemUnitMessages,
} from './priceListMessages';

export const PriceListItemListItem: React.FC<PriceListItemResponse> = (props) => {
  const { appType } = useAppContext();
  const formatMessage = useMessage();
  const routeToPriceListItemDetail = useHistoryAction('vydejPriceListItemDetail', { id: props.id });

  // Datová položka cenu za jednotku nemá — místo ní se vypíše rozpětí cen pásem.
  const isDataType = isDataPriceListItemType(props.type);
  const bandsPriceRange = getPriceBandsPriceRange(props.bands);
  const unitLabel = props.unit
    ? (formatMessage.lookup(priceListItemUnitMessages, props.unit as PriceListItemUnitsEnum) ??
      props.unit)
    : null;

  const handleClick = useCallback(
    (event: React.MouseEvent) => {
      if (event.ctrlKey || event.metaKey) {
        window.open(
          getCmdCtrlUrl('vydejPriceListItemDetail' as RouteId, { appType, id: props.id }),
          '_blank',
        );
        return; // Ponech nativní chování
      }

      const selectText = window.getSelection();
      if (!selectText || selectText.toString() === '') {
        routeToPriceListItemDetail();
      }
    },
    [routeToPriceListItemDetail, appType, props.id],
  );

  return (
    <tr onClick={handleClick}>
      <td className='sg-u-type-bold'>{props.name}</td>
      <td>{formatMessage.lookup(priceListItemTypeMessages, props.type) ?? props.type}</td>
      <td>{unitLabel}</td>
      <td className='sg-a-ta-r sg-a-ws-nw sg-a-fvn-tn'>
        {isDataType ? (
          bandsPriceRange &&
          (bandsPriceRange.min === bandsPriceRange.max ? (
            <FormattedMessage {...msg.bandsPriceCzk} values={{ price: bandsPriceRange.max }} />
          ) : (
            <FormattedMessage {...msg.bandsPriceRange} values={bandsPriceRange} />
          ))
        ) : (
          <FormattedMessage {...msg.priceCzk} values={{ price: props.unit_price }} />
        )}
      </td>
      <td className='sg-a-ta-r sg-a-ws-nw sg-a-fvn-tn'>
        <FormattedMessage {...msg.percent} values={{ value: props.vat_rate }} />
      </td>
      <td className='sg-a-ta-r sg-a-ws-nw sg-a-fvn-tn'>
        {props.unit_price_with_vat && (
          <FormattedMessage {...msg.priceCzk} values={{ price: props.unit_price_with_vat }} />
        )}
      </td>
      <td className='sg-a-ta-r sg-a-ws-nw sg-a-fvn-tn'>
        <FormattedDate value={new Date(props.created)} />{' '}
        <FormattedTime value={new Date(props.created)} />
      </td>
    </tr>
  );
};
